module.exports = __webpack_public_path__ + "static/img/screenkey2.56e510a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/remotekey/screen/screenkey2.gif
// module id = oTrP
// module chunks = 0